class NavigationDesktop extends HTMLElement {
  constructor() {
    super();

    this.links = this.querySelectorAll(".header__shop-item--list > ul > li");
    this.products = this.querySelectorAll(
      ".header__shop-item--products .header__shop-item__products"
    );
    this.blogs = this.querySelectorAll(
      ".header__shop-item--blog .header__shop-item__blog"
    );

    this.activeHandle = this.links[0]?.dataset.handle || "default";

    this.addEventListener("mouseover", (evt) => {
      const handle = evt.target.closest("[data-handle]");

      if (
        !handle ||
        handle.dataset.handle === this.activeHandle ||
        evt.target.tagName !== "SPAN"
      )
        return;

      this.updateLink(handle);
    });

    this.addEventListener("click", (evt) => {
      const url = evt.target.closest("[data-url]");

      if (evt.target.tagName !== "SPAN" || !url || !url.dataset.url) return;

      window.location.assign(url.dataset.url);
    });
  }

  updateLink(handle) {
    this.activeHandle = handle.dataset.handle;

    this.links.forEach((link) => {
      link.classList.toggle(
        "active",
        link.dataset.handle === this.activeHandle
      );
    });

    this.products.forEach((product) => {
      product.classList.toggle(
        "active",
        product.dataset.handle === this.activeHandle
      );
    });

    this.blogs.forEach((banner) => {
      banner.classList.toggle(
        "active",
        banner.dataset.handle === this.activeHandle
      );
    });
  }
}

customElements.define("navigation-desktop", NavigationDesktop);
